export default __webpack_public_path__ + "static/media/corners.35f17fd6.md";